import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	name: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.name',
		defaultMessage: 'Name',
		description: 'Table head title for the name of a priority scheme associated with projects',
	},
	priorities: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.priorities',
		defaultMessage: 'Priorities',
		description: 'Table head title for priorities in a priority scheme associated with projects',
	},
	projects: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.projects',
		defaultMessage: 'Projects',
		description: 'Table head title for projects associated with a priority scheme',
	},
	actions: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.actions',
		defaultMessage: 'Actions',
		description:
			'Table head title to specify available actions for a priority scheme associated with projects',
	},
	edit: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.edit',
		defaultMessage: 'Edit',
		description: 'Action button to edit priority scheme',
	},
	delete: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.delete',
		defaultMessage: 'Delete',
		description: 'Action button to delete priority scheme',
	},
	noSearchResults: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.no-search-results',
		defaultMessage: 'We couldn’t find what you’re looking for. Try searching for another scheme.',
		description:
			'Message to display when there are no search results for priority schemes in the table',
	},
	paginatorSummary: {
		id: 'admin-pages-priority-schemes.priority-schemes-table.paginator-summary',
		defaultMessage:
			'Showing {startRow} - {endRow} of {totalRows, plural, one {# priority scheme} other {# priority schemes}}',
		description:
			'Summary of current rows being shown in the table. {startRow} and {endRow} is the limit of rows currently visible on the table (e.g. 1 to 5). {totalRows} is total count of priority schemes available for this Jira instance (e.g. 70).',
	},
});
